function getPriceForFinanceKey(vehicle, key) {
    // PCP key is now PCP_STOCK, but the db column is still PCP
    if (key == 'PCP_STOCK') {
        key = 'PCP';
    }
    const price = parseFloat(vehicle['price_' + key] || 0.00);
    if (price > 0) {
        return price;
    }
    if (vehicle.vat_type == 'vat') {
        return parseFloat(vehicle.vat_price) * 1.2;
    }
    return parseFloat(vehicle.vat_price);
}

function getHaloOfferRequest(vehicle) {
    const haloDetails = JSON.parse(vehicle.halo_offer_details);
    const price = parseInt(haloDetails.price);

    const request = {
        "Dealer": "Stellantis &You Peugeot West London",
        "Id": vehicle.id + '_' + price,
        "Vehicle": {
            "CashPrice": price,
            "CurrentMileage": 0,
            "DealerVehicleUrl": "",
            "imageUrl": "",
            "IsNew": true,
            "RegistrationDate": vehicle.codeweavers_date_registered,
            // "StockId": vehicle.id,
            "Type": (vehicle.van == 1) ? 'Lcv' : 'Car',
        },
        "Products": [
            {
                "Key": haloDetails.type,
                "OverrideFinanceParameters": {
                    "Term": haloDetails.term,
                    "Deposit": haloDetails.deposit,
                    "DepositType": "Amount",
                    "AnnualMileage": haloDetails.mileage,
                    "IsTelematics": false,
                }
            }
        ],
    };

    if (vehicle.titre_code != null && vehicle.titre_code != '') {
        request.Vehicle.Identifier = vehicle.titre_code;
        request.Vehicle.IdentifierType = "Titre";
    } else {
        request.Vehicle.Identifier = vehicle.cap_id;
        request.Vehicle.IdentifierType = 'CapShortCode';
    }

    return request;
}

/**
 * Get the codeweavers calculate request for this vehicle
 * @param {Object} vehicle
 * @param {Object} allKeys All keys, keyed under "new" and "used" depending on the vehicle
 * @returns
 */
export default function(vehicle, allKeys) {
    let type = 'Car';
    if (vehicle.van == 1) {
        type = 'Lcv';
    }

    if (vehicle.is_halo_offer) {
        return [getHaloOfferRequest(vehicle)];
    }

    let keys = allKeys[(vehicle.is_new == 1) ? 'new' : 'used'] || [];

    // Get price ranges because we need to return a Codeweavers vehicle object for each unique price
    let priceRanges = {};
    for (let index = 0, len = keys.length; index < len; index++) {
        let key = keys[index];
        const priceForKey = getPriceForFinanceKey(vehicle, key);
        if (priceForKey > 0 && typeof priceRanges[priceForKey] == 'undefined') {
            priceRanges[priceForKey] = {
                "Products": []
            };
        }

        let productKey = {
            "Key": key,
        }

        priceRanges[priceForKey].Products.push(productKey);
    }

    let data = [];
    Object.keys(priceRanges).forEach(price => {
        let vehicleObject = {
            "Id": vehicle.id + '_' + price,
            "Dealer": vehicle.codeweavers_dealership_id,
            "Vehicle": {
                "CashPrice": price,
                "CurrentMileage": vehicle.mileage,
                "RegistrationDate": vehicle.codeweavers_date_registered,
                "IsNew": (vehicle.is_new == 1) ? true : false,
                "Identifier": vehicle.reg_no,
                "IdentifierType": "Vrm",
                "Type": type,
                "StockId": vehicle.id,
                "imageUrl": "",
                "DealerVehicleUrl": "",
            },
            "Products": priceRanges[price].Products
        };

        if (vehicle.is_new == 1) {
            vehicleObject.Vehicle.Vin = vehicle.reg_no;
            // if (vehicle.base_price > 0) {
            //     vehicleObject.Vehicle.CostBreakdown = {
            //         BasePrice: vehicle.base_price,
            //         Delivery: vehicle.delivery,
            //         RoadFundLicence: vehicle.road_fund_licence,
            //         RegistrationFee: vehicle.registration_fee,
            //         GovernmentGrant: vehicle.government_grant,
            //         OtrPrice: price,
            //     };
            // }
        }
        if (vehicle.is_new == 1 && vehicle.manufacturer.toLowerCase() != 'vauxhall' && vehicle.titre_code != null && vehicle.titre_code != '') {
            vehicleObject.Vehicle.Identifier = vehicle.titre_code;
            vehicleObject.Vehicle.IdentifierType = 'Titre';
        } else if (vehicle.cap_id != null && vehicle.cap_id > 0) {
            vehicleObject.Vehicle.Identifier = vehicle.cap_id;
            vehicleObject.Vehicle.IdentifierType = 'CapShortCode';
        } else if (vehicle.is_new == 1) {
            vehicleObject.Vehicle.IdentifierType = 'Vin';
        }

        data.push(vehicleObject);
    });

    return data;
}